import React, { useEffect, useState } from 'react'
import styles from './styles.module.scss'

// One progress bar across the form (eligibility → claim form). It never shows
// a step count, and it moves in big jumps early and smaller ones later, so the
// form feels short and nearly done by the end. Signing and uploads come after
// the claim is submitted, as extra parts with no bar.
export const JOURNEY_PROGRESS = {
    eligibility: [10, 18, 26],
    claim: [42, 55, 68, 78, 88, 96],
}

// Last width shown, so the next stage animates on from here instead of from 0.
let lastShown = 0

interface JourneyProgressProps {
    percent: number
    label?: string
    className?: string
}

const JourneyProgress: React.FC<JourneyProgressProps> = ({ percent, label, className }) => {
    const [width, setWidth] = useState(lastShown)

    useEffect(() => {
        const frame = requestAnimationFrame(() => setWidth(percent))
        lastShown = percent
        return () => cancelAnimationFrame(frame)
    }, [percent])

    return (
        <div className={`${styles.journeyProgress} ${className || ''}`}>
            {label && <span className={styles.label}>{label}</span>}
            <div
                className={styles.track}
                role="progressbar"
                aria-label="Claim progress"
                aria-valuenow={percent}
                aria-valuemin={0}
                aria-valuemax={100}
            >
                <div className={styles.fill} style={{ width: `${width}%` }} />
            </div>
        </div>
    )
}

export default JourneyProgress
